import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from '../../Base';
import { Header } from '../../Header';
import { Footer } from '../../Footer';
import EmployeeEnterExit from "./EmployeeEnterExit";

export default class EmployeeEnterExits extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'employeeenterexit',
            caller: props.Caller,
            inline: this.isNull(props.Inline) ? false : props.Inline,
            data: null,
            loading: true,
            page: 1,
            per_page: 30,
            phrase: '',
            menuId: 209
        };
        this.state.filters = {
            personId: this.isNull(props.PersonId) ? null : props.PersonId
        }
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.refreshData();
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <EmployeeEnterExit Caller={this} Data={this.state.data} /> });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">لیست ورود و خروجها</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} تردد یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head nk-block-head-sm">
                            <div className="nk-block-between">
                                <div className="nk-block-head-content">
                                    <div className="nk-block-des text-soft">
                                        <p>{this.money(this.state.data.recordsCount)} داده ای یافت شد</p>
                                    </div>
                                </div>
                                <div className="nk-block-head-content">
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                        <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                        <div className="toggle-expand-content" data-content="pageMenu">
                                            <ul className="nk-block-tools g-3">
                                                <li>
                                                    <a className="hand btn btn-primary" onClick={e => this.onAdd()}><span className="shortcut">F2 - </span><span> جدید</span></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="nk-block">
                            <div className="card card-bordered card-stretch">
                                <div className="card-inner-group">
                                    <div className="card-inner position-relative card-tools-toggle">
                                        <div className="card-title-group">
                                            <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                                <div className="form-inline flex-nowrap gx-3">
                                                    <div className="form-wrap">
                                                        <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="نام شخص" className="form-control" />
                                                    </div>
                                                    <div className="btn-wrap">
                                                        <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                    {this.state.data.recordsCount <= 0 ?
                                        <div className="card-inner-group">
                                            <div className="example-alert">
                                                <div className="alert alert-pro alert-warning">
                                                    <div className="alert-text">
                                                        <h6>توجه</h6>
                                                        <p>هیچ داده ای یافت نشد</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <div className="card-inner p-0">
                                            <div className="nk-tb-list nk-tb-ulist">
                                                <div className="nk-tb-item nk-tb-head">
                                                    <div className="nk-tb-col text-center"><span className="sub-text">نام شخص</span></div>
                                                    <div className="nk-tb-col text-center"><span className="sub-text">تاریخ ورود</span></div>
                                                    <div className="nk-tb-col text-center"><span className="sub-text">ساعت ورود</span></div>
                                                    <div className="nk-tb-col text-center"><span className="sub-text">تاریخ خروج</span></div>
                                                    <div className="nk-tb-col text-center"><span className="sub-text">ساعت خروج</span></div>
                                                    <div className="nk-tb-col text-center"><span className="sub-text">مدت حضور</span></div>
                                                </div>
                                                {this.state.data.records.map((record, index) =>
                                                    <div className="nk-tb-item">
                                                        <div className="nk-tb-col">
                                                            <span className="onlyMobile">نام شخص: </span>
                                                            <span className="sub-text text-center">{record.personName}</span>
                                                        </div>
                                                        <div className="nk-tb-col">
                                                            <span className="onlyMobile">تاریخ ورود: </span>
                                                            <span className="sub-text text-center">{record.enterDateString}</span>
                                                        </div>
                                                        <div className="nk-tb-col">
                                                            <span className="onlyMobile">ساعت ورود: </span>
                                                            <span className="sub-text text-center">{record.enterTimeString}</span>
                                                        </div>
                                                        <div className="nk-tb-col">
                                                            <span className="onlyMobile">تاریخ خروج: </span>
                                                            <span className="sub-text text-center">{record.exitDateString}</span>
                                                        </div>
                                                        <div className="nk-tb-col">
                                                            <span className="onlyMobile">ساعت خروج: </span>
                                                            <span className="sub-text text-center">{record.exitTimeString}</span>
                                                        </div>
                                                        <div className="nk-tb-col">
                                                            <span className="onlyMobile">مدت حضور: </span>
                                                            <span className="sub-text text-center">{record.durationString}</span>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    }
                                    {this.createPaging()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,

                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                ,
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}